import { clsx } from 'clsx'
import css from 'component/Carousel/co/Slide.module.scss'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'

type Props = {
  children: ReactElement
}

export const Slide = observer(({ children }: Props) => {
  const className = clsx('slide', css.slide)

  return <div className={className}>
    <div className={css.inner}>
      {children}
    </div>
  </div>
})
